import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          // redirect: '/dashboard/analytics'
          redirect: '/dust/map'
          // redirect: '/admin/report'
        },
        //FOUR
        {
          path: '/dust/map',
          name: 'air-quality-map',
          component: () => import('./views/AirQualityMap.vue'),
          meta: {
            rule: 'public'
          }
        },
        //FOUR
        {
          path: '/dust/report/:id',
          name: 'air-quality-report',
          component: () => import('./views/AirQualityReport.vue'),
          meta: {
            rule: 'public'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/change-password',
          name: 'page-change-password',
          component: () => import('@/views/pages/ChangePassword.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'public'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    },
    {
      path: '',
      component: () => import('./layouts/main/MainAdmin.vue'),
      children: [
        // =============================================================================
        // ADMIN REPORT , HISTORY , MANAGE , MEASURING POINT
        // =============================================================================
        {
          path: '/admin/report',
          name: 'admin-report',
          component: () => import('./views/AdminReport.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/admin/history',
          name: 'admin-history',
          component: () => import('./views/AdminHistory.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/admin/manage',
          name: 'admin-manage',
          component: () => import('./views/AdminManage.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/admin/measuring-point',
          name: 'admin-measuring-point',
          component: () => import('./views/AdminMeasuringPoint.vue'),
          meta: {
            rule: 'admin'
          }
        }
      ]
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

// router.beforeEach((to, from, next) => {
//
// })

export default router
